import React, {useEffect, useState} from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useHistory } from 'react-router'

import { pelangganJenisFormData } from './pelangganJenisFormData'
import { pelangganJenisTable } from './pelangganJenisTable'

// Component
import CardTable from "components/Cards/CardTable"
import FormCustom from "components/Forms/FormCustom"
import ConfirmModal from 'components/Modal/ConfirmModal'

// API
import { deletePelangganJenis, getAllDataTablePelangganJenis, insertNewPelangganJenis, updatePelangganJenis } from './api/pelangganJenisAPI'

export default function PelangganJenis() {
    const history = useHistory();
    
    const [addForm, setAddForm] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editFormValue, setEditFormValue] = useState(null);

    const [dataTable, setDataTable] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);

    const [active, setActive] = useState(false);

    const [formData, setFormData] = useState(null);
    
    const [formDataArr, setFormDataArr] = useState([]);

    // Type Search
    const [typeSearch, setTypeSearch] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [errors, setErrors] = useState(null);
    const [deletePopUp, setDeletePopUp] = useState([{show:false, id:null}])

    // Component is Active?
    useEffect(() => {
        setActive(true);
        return () => {
            setActive(false)
        }
    }, [])

    // Loading
    useEffect(() => {
        if(isLoading === true) {
            toast.loading("Data Diproses...");
        }
    }, [isLoading])

    // handle when state active changed
    useEffect(() => {
        setIsLoading(true);

        getAllDataTablePelangganJenis().then((response) => {
            active === true && setDataTable(response.data.data)
        })
        .catch(error => console.error(`Error: ${error}`))
        .finally(setIsLoading(false))

        return () => {
            setDataTable([]);
        }
        
    }, [active])

    // Clear Form Data When First Time Load Component
    useEffect(() => {
        setFormData(null);
    }, [])

    // Load Form Data Arr
    useEffect(() => {
        setFormDataArr(pelangganJenisFormData());

        return () => {
            setFormDataArr([])
        }
    }, [])

    // Clear Form Data When First Time Load Component
    useEffect(() => {
        setFormData(null);
    }, [active]);

    // Handle when user click add button
    function handleInsert() {
        setActive(false);
        setAddForm(true);
    }

    // Handle when User Click Cancel
    const handleCancelButton = () => {
        setAddForm(false);
        setEditForm(false);
        setEditFormValue(null);
        setFormData(null);
        setActive(true);
    }

    // Handle when User Click Edit Button
    const handleEdit = (rowData) => {
        setActive(false)
        setEditFormValue(rowData);
        setEditForm(true);
    }

    // Handle when User Click Delete Button
    const handleDelete = (rowData) => {
        setDeletePopUp({
            show: true,
            id: rowData.id_pelanggan_jenis
        })
    }

    // Handle when User Confirm to Delete Data
    const handleDeleteTrue = () => {
        setActive(false)
        if(deletePopUp.show && deletePopUp.id) {
            setIsLoading(true);

            deletePelangganJenis(deletePopUp.id)
            .then((response) => setResult(response))
            .catch((err) => setErrors(err))
            .finally(endSubmitProcess())
        }
    }

    // Handle when User Deny to Confirm Delete Data
    const handleDeleteFalse = () => {
        setDeletePopUp({
            show: false,
            id: null
        })
    }

    // Handle when User Submit New Data
    const handleInsertSubmit = (e) => {
        e.preventDefault();

        setIsLoading(true);

        insertNewPelangganJenis(formData)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }

    // Handle when USer Submit Update Data
    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        if(formData !== null) {
            const id = editFormValue.id_pelanggan_jenis;

            setIsLoading(true);

            updatePelangganJenis(formData, id)
            .then((response) => setResult(response))
            .catch((err) => setErrors(err))
            .finally(endSubmitProcess());

        } else {
            toast.error("Tidak ada data yg di ubah");
        }
    }

    //Check if request is failed
    useEffect(() => {
        if(errors !== null) {
            toast.error(errors.message);
            }
    }, [errors])

    // Check if request is success
    useEffect(() => {
        if(result !== null) {
            if(result.data.success === true) {
                toast.success(result.data.message);
                setFormData(null);
                setAddForm(false);
                setEditForm(false);
                setActive(true);
                history.push(`/config/PelangganJenis`);
            } else {
                let numericArray = [];
                for (let err in result.data.errors) {
                    numericArray.push(result.data.errors[err])
                }

                if(numericArray !== []) {
                    toast.error(numericArray[0]);
                }
            }
            setResult(null);
        }
    }, [history, result])

    // Set Inputted Data to Form
    const setData = (key, value) => {
        return setFormData({...formData, [key]: value});
    }

    // Handle when submit process is end
    const endSubmitProcess = () => {
        setDeletePopUp({show: false})
        setIsLoading(false);
    }

    // Handle Search
    const handleSearch = (e) => {
        setTypeSearch(e.target.value);
    }

    // Handle when Searching Changes
    useEffect(() => {
        const getDataSearchResult = () => {
            getAllDataTablePelangganJenis(typeSearch)
            .then((response) => {
                setDataTable(response.data.data)
            })
            .catch(error => console.error(`Error: ${error}`))
            .finally(setIsLoading(false))
            setPageNumber(0);
        }

        const getData = () => {
            getAllDataTablePelangganJenis()
            .then((response) => {
                setDataTable(response.data.data);
            })
            .catch(error => console.error(`Error: ${error}`))
            .finally(setIsLoading(false));
            setPageNumber(0);
        }

        let timer = setTimeout(() => {
            if(typeSearch) {
                    getDataSearchResult();
                } else {
                    getData();
                }
        }, 1000);

        return () => clearTimeout(timer)
    }, [typeSearch]);

    // Handle when Page number Changes
    const changePage = ({selected}) => {
        setPageNumber(selected);
    }

    if(addForm === true) return (
        <div>
            <div className='flex flex-wrap mt-4'>
                <div className='w-full mb-12 px-4'>
                    <Toaster />
                    <FormCustom
                        title = {"Tambah Data"}
                        formDataArr = {formDataArr}
                        handleSubmit = {handleInsertSubmit}
                        handleCancelButton = {handleCancelButton}
                        setData = {setData}
                        editFormValue ={null}
                    />    
                </div>
            </div>
        </div>
    );

    if(editForm === true) return (
        <div>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <Toaster />
                    <FormCustom
                        title = {"Edit Data"}
                        formDataArr = {formDataArr}
                        handleSubmit = {handleUpdateSubmit}
                        handleCancelButton = {handleCancelButton}
                        setData = {setData}
                        editFormValue = {editFormValue}
                    />
                </div>
            </div>
        </div>
    )

    return (
        <div>
            <div className='flex flex-wrap mt-4'>
                <div className='w-full mb-12 px-4'>
                    {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleDeleteTrue()} handleIfFalse={(e) => handleDeleteFalse()} /></div>}
                    <Toaster />
                    <CardTable
                        tableTitle = "Tabel Jenis Pelanggan"
                        cols = {pelangganJenisTable(handleEdit, handleDelete)}
                        handleInsert = {(e) => handleInsert()}
                        data = {dataTable}
                        handleSearch = {handleSearch}
                        pageNumber = {pageNumber}
                        changePage = {changePage}
                    />
                </div>
            </div>
        </div>
    )
}